import { TUserGroupActionLevelItem } from '../components/user-group-lists-modal/list/types';

export const COUNTRIES_LEVEL_EVENTS_LABELS = ['все страны', 'ареалы', 'группы стран', 'страны'] as const;
export const REGIONS_RF_LEVEL_EVENTS_LABELS = ['РФ', 'округа', 'субъекты'] as const;

export const PRODUCT_ACTION_LEVELS: TUserGroupActionLevelItem[] = [
  { level: 1, label: 'товарные группы' },
  { level: 2, label: 'на 2 знаках' },
  { level: 3, label: 'на 4 знаках' },
  { level: 4, label: 'на 6 знаках' },
  { level: 5, label: 'на 8 знаках' },
  { level: 6, label: 'на 9 знаках' },
  { level: 7, label: 'на 10 знаках' },
];
